module.exports = __webpack_public_path__ + "img/IMG_8618_L_Wood_MockedUp.cd86f70b.jpg";